import React, { Component } from 'react'
import {inject} from "mobx-react";
import {Label, Col, Row, FormGroup, Form, Input, CustomInput} from "reactstrap";
import {observer} from "mobx-react";
import _ from "lodash";
import CRUDAnaliseCriticaStore from "../stores/CRUDAnaliseCriticaStore";
import ModalForm from "../../comum/components/ModalForm";
import FormInputSimples from "../../comum/components/FormInputSimples";
import FormInput from "../../comum/components/FormInput";
import FormOnlyPositiveNumberSimples from "../../comum/components/FormNumberSimples";
import {IconeFechar, IconeInformacao, IconeCarregar, Baixar} from "../../comum/components/Icones";
import CheckboxField from '../../comum/components/CheckboxField';
import {splitBR} from "../../../utils/formatar";
import { formatarCNPJ } from '../../../utils/functions';
import { sanitizarRadical } from '../../../utils/sanitizar';

@inject("store")
@observer
export class ModalAnaliseCriticaForm extends Component {
    constructor(props) {
        super(props);
        this.controller = new CRUDAnaliseCriticaStore(this.props.service);
        this.controllerAnalise = this.props.controller;
        this.validacaoStore = this.props.store.validacaoStore;

        this.chamaValidacao = this.chamaValidacao.bind(this)
    };

    componentDidMount() {
        this.controller.listarTiposMercadoria()
        if (this.controllerAnalise.editar) {
            this.controller.carregarAnalise(this.controllerAnalise.editar);
            this.controller.configurarModalEditar(this.controllerAnalise.editar);

        } else if (this.controllerAnalise.enviar) {
            this.controller.enviarAnalise(this.controllerAnalise.enviar);
            this.controller.configurarModalEnviar(this.controllerAnalise.enviar);

        } else {
            this.controller.configurarModalCadastrar();
        }
    };

    validacaoUn = () => {
        this.controller.erroUN = ""
        if(!(_.get(this.controller.analise,"CdImo")) && this.controller.campoUn){
            this.controller.erroUN = "Campo obrigatório"
        }
    }

    validacaoCnpj = () => {
        this.controller.erroRadical = ""
        this.controller.erroCNPJ = ""
        if(!(_.get(this.controller.analise,"radical")) && this.controller.modalConfig.tipoModal === "Cadastrar"){
            this.controller.erroRadical = "Campo Obrigatório"
        }else if(this.controller.getParceirosSelecionados().length === 0){
            this.controller.erroCNPJ = "Escolha um CNPJ"
        }
    }

    validacaoEmail = (event) => {
        this.controller.alertaEmail = ""
        if(!_.get(this.controller.analise, "Email")){
            this.controller.alertaEmail = "Campo obrigatório"
        }else{
            //TODO criar validação que aceita entrada com espaços
            const emails = (_.get(this.controller.analise, "Email")).split(',')
            emails.map(email => {
                if(!(this.validacaoStore.isEmail(email))){
                    this.controller.alertaEmail = "Insira um endereço de email válido"
                }
            })
        }
    }

    validacaoNcm = () => {
        if(!_.get(this.controller.analise,"Ncm")){
            this.controller.erroNCM = "Campo obrigatório"
        }else{
            // Eu não posso sempre limpar o campo de mensagem para NCM
            // só posso fazer isso se ele for preenchido corretamente e a mensagem ainda for "Campo obrigatório"
            // já que há outras possíveis mensagens
            if(this.controller.erroNCM === "Campo obrigatório") this.controller.erroNCM = ""
        }
    }

    avisoNCM = () => {
        let mensagem = "Esse tipo de mercadoria só pode ser desovada na modalidade crossdoking.";

        return this.controller.mensagemCrossdoking &&
               <Col xs={12} sm={12} md={12} lg={12} xl={12} className="mb-4 aviso-ncm">
                    <IconeInformacao className={'mr-2 mb-1'}/>
                    <Label className={'mb-0 aviso-form'}>{mensagem}</Label>
               </Col>
    };

    avisopProdQuim = () => {
        let mensagem = "Para produtos químicos, é obrigatória a inclusão da FISPQ. Caso não seja inserida, essa análise será retornada.";

        return this.controller.mensagemProdQuim &&
                <Col xs={12} sm={12} md={12} lg={12} xl={12} className="pl-2 ml-3 mb-4 d-flex justify-content-start align-items-center">
                <Row className="pb-0">
                    <div className="flex-row d-flex align-items-center">
                        <IconeInformacao className={'mr-2 icone-aviso'} />
                        <Label className="mb-0 aviso-form">{mensagem}</Label>
                    </div>
                </Row>
            </Col>
    };

    avisoAnexo = () => {
        let mensagem = "Documentos essenciais: BL, Packing list, FISPQ, Ficha de emergência (obrigatório para químico/classificado)";

        return <Col xs={12} sm={12} md={12} lg={8} xl={8} className="d-flex justify-content-center align-items-center">
                    <Row className="pb-0">
                        <div className="flex-row d-flex align-items-center">
                            <IconeInformacao className={'mr-2 icone-aviso'} />
                            <Label className="mb-0 aviso-form">{mensagem}</Label>
                        </div>
                    </Row>
                </Col>
    };

    campoAnexo = () => {
        return <Row className={'px-3'}>
                    <Col xs={12} sm={12} md={6} lg={4} xl={4}>
                        <Label>Anexos</Label>
                        <span className="label-danger">*</span>
                        <Input className="p-2 mb-4" type="file" onChange={e => this.controller.anexarArquivo(e)} accept=".csv, .xml, .txt, .xls, .xlsx, .doc, .pdf" multiple />
                    </Col>
                    { this.avisoAnexo() }
                    { this.controller.listaAnexos.length > 0 &&
                        <Col xs={12} md={12} className="mb-4">{
                            this.controller.listaAnexos.map((item, index) =>
                                <div key={index} className={`item-anexo`}>
                                    <span>{`${item.DscAnex}.${item.DscExtenAnex}`}</span>
                                    <span>
                                        <Baixar tamanho="lg" className="mr-2" cor="#001c43" onClick={() => this.controller.baixarAnexo(item.Id, index)} />
                                        <IconeFechar tamanho="lg" onClick={() => this.controller.removerAnexo(item.Id,index)}/>
                                    </span>
                                </div>
                            )}
                        </Col>
                    }
               </Row>
    };

    camposDadosArmazenamento = () => {
        return <Row className={'px-3 dados-armazenamento mb-2'}>
                    <Col lg={12} xl={12}><Label className={'mb-3'}>Dados de armazenamento</Label></Col>
                    { this.controller.dadosArmazenamento.map(item =>
                        <CheckboxField key={item.valor}
                                       sm={12} md={4} lg={4}
                                       text={item.label}
                                       ativo={parseInt(_.get(this.controller.analise, item.valor))}
                                       onClick={(event) => this.controller.setCampoAnalise(item.valor, event ? 1 : 0)}
                        />
                    )}
               </Row>
    };

    cnpjsGrupos = () => {
        if(this.controller.grupoCnpjs.length) {
            return <div>
                        <Row className="pb-0 mt-2">
                            <Col sm={12}><Label>CNPJ's do grupo</Label></Col>
                        </Row>
                        <Col className="grupoCnpjs mb-5">
                            <Row className="pb-0">
                                <div className={`${this.controller.grupoCnpjs.length > 6 ? "grupoCnpjs-content-overflow" : "grupoCnpjs-content"}`}>
                                    <Col className="grupoCnpjs-container">
                                        {this.controller.grupoCnpjs.map( (item,index) =>
                                            <Row className="align-items-center justify-content-between pb-2 px-3"
                                                key={index}
                                                onClick={() => this.controller.selecionarParceiro(index)}>
                                                <Col sm={8}>{formatarCNPJ(item.Cgc)}</Col>
                                                <Col className='pr-0 d-flex justify-content-end checkbox-col'>
                                                    <label className="control control-checkbox">
                                                        <span>
                                                            <input type="checkbox" className={this.controller.atualizarSelParceiro ? 'atualizar' : ''}
                                                                onClick={() => this.controller.selecionarParceiro(index)}
                                                                checked={_.get(item,'selecionado')} />
                                                            <div className="control_indicator"></div>
                                                        </span>
                                                    </label>
                                                </Col>
                                            </Row>
                                        )}
                                    </Col>
                                </div>
                            </Row>

                            <Row className="p-3 pr-5 align-items-center control-checkboxes">
                                <Col><span>{this.controller.grupoCnpjs.length}</span> {this.controller.grupoCnpjs.length === 1 ? "CNPJ relacionado " : "CNPJs relacionados"} </Col>
                                <Col className="d-flex flex-row align-items-center justify-content-end checkbox-col pb-0">
                                    <span 
                                        onClick={(event) => this.controller.marcarCnpjs(event)}>
                                        Selecionar todos
                                    </span>
                                    <Label className="control control-checkbox">
                                        <span>
                                            <input type="checkbox" onChange={(event) => this.controller.marcarCnpjs(event)} />
                                            <div className="control_indicator"></div>
                                        </span>
                                    </Label>
                                </Col>
                            </Row>
                            {this.controller.erroCNPJ !== "" && <Col><Label className="label-danger mensagem">{ this.controller.erroCNPJ }</Label></Col>}
                        </Col>
                    </div>
        }
    };

    mensagemSubmit = () => {
        if(this.controller.mensagemErro){
            return <Col className='mb-0 pr-0 text-right col label-danger'>{splitBR(this.controller.mensagemErro)}</Col>
        }
        else if(this.controller.mensagemSucesso){
            return <Col className='mb-0 pr-0 text-right col label-primary'>{splitBR(this.controller.mensagemSucesso)}</Col>
        }
    };

    form = () => {
        if(this.controllerAnalise.enviar || this.controller.envioConcluido || this.controller.salvarConcluido){
            return null
        } else {
            return <FormGroup>
                <Row className="pb-0">
                    <FormInput titulo="CPF/Radical do CNPJ importador" 
                        xs={12} sm={12} md={6} lg={4} xl={4}
                        carregando={this.controller.carregandoRadical}
                        dado={_.get(this.controller.analise, "radical")}
                        obrigatorio={true}
                        alerta={this.controller.erroRadical}
                        limiteMaximo={11}
                        sanitizar={sanitizarRadical}
                        onChange={(event) => this.controller.setCampoAnalise("radical", event)}
                        onBlur={() => this.controller.listarParceiroPorRadical()}/>
                    {!this.controller.carregandoRadical 
                    && <FormInputSimples titulo="Razão social" xs={12} sm={12} md={6} lg={8} xl={8}
                                      bloqueado={true}
                                      dado={this.controller.razaoSocial}
                    />}
                </Row>
                {this.cnpjsGrupos()}
                <Row>

                    <FormOnlyPositiveNumberSimples titulo="NCM" xs={12} sm={12} md={6} lg={4} xl={4}
                                                   obrigatorio={true}
                                                   dado={_.get(this.controller.analise, "Ncm")}
                                                   carregando={this.controller.carregandoNCM}                                                   
                                                   alerta={ this.controller.erroNCM }
                                                   onEnter = {() => this.controller.carregarNCM()}
                                                   onChange={(event) => this.controller.setCampoAnalise("Ncm", event)}
                                                   onBlur={() => this.controller.carregarNCM()}/>


                    <FormInputSimples titulo="Descrição da mercadoria" xs={12} sm={12} md={6} lg={8} xl={8}
                                      bloqueado={true}
                                      dado={_.get(this.controller.analise, "DscMerc")}/>

                    {this.avisoNCM()}

                    <Col xs={12} sm={12} md={12} lg={9} xl={9} className="pb-0">
                        <Row>
                            <Col className="form-input-simples">
                                <Label>Classificação da Mercadoria <span className="label-danger">*</span></Label>
                                <div className="d-flex mt-2">
                                    {this.controller.tiposMercadoria.map(tipo => {
                                        return(<span className="mr-4 d-inline-flex align-items-center">
                                            <input
                                                type="radio"
                                                id={tipo.id}
                                                value={tipo.value}
                                                name="mercadoria"
                                                checked={tipo.checked}
                                                onClick={(event) => {
                                                    this.controller.setRadioChecked(event.target.value)
                                                    this.controller.mostrarAvisoProdQuim(event.target.value)
                                                    this.controller.setCampoAnalise("IndTipoMerc", event.target.value); //TODO preciso dos valores exatos para mandar para FlgProdQuim
                                                    this.controller.mostrarCampoUn(event.target.value === "QC" ? true : false)
                                                    if (!_.get(this.controller.analise, "IndTipoMerc")) {
                                                        this.controller.setCampoAnalise('classificacao', "");
                                                    }
                                                }}
                                            />
                                            <label className="mb-0 ml-1" htmlFor={tipo.id}>{tipo.label}</label>
                                        </span>)
                                    })}
                                </div>
                            </Col>
                        </Row>
                    </Col>

                   {this.controller.campoUn
                        && <FormInputSimples titulo="Classificação UN" xs={12} sm={12} md={6} lg={3} xl={3}
                                      dado={_.get(this.controller.analise, "CdImo")}
                                      alerta={this.controller.erroUN}
                                      obrigatorio={true}
                                      limiteMaximo={6}
                                      onChange={(event) => this.controller.setCampoAnalise("CdImo", event)}/>}

                    {this.avisopProdQuim()}

                    <FormInputSimples titulo="E-mail" xs={12} sm={12} md={12} lg={12} xl={12}
                                      dado={_.get(this.controller.analise, "Email")}
                                      alerta={this.controller.alertaEmail}
                                      limiteMaximo={100}
                                      obrigatorio={true}
                                      onChange={(event) => this.controller.setCampoAnalise("Email", event)}/>

                    {this.camposDadosArmazenamento()}

                    {this.campoAnexo()}

                    <FormInputSimples titulo="Observações" xs={12} sm={12} md={12} lg={12} xl={12}
                                      dado={_.get(this.controller.analise, "DscObs")}
                                      alerta={''}
                                      type="textarea"
                                      limiteMaximo={2000}
                                      onChange={(event) => this.controller.setCampoAnalise("DscObs", event)}/>
                </Row>
            </FormGroup>
        }
    };

    esconderSalvar = () => {
        return (this.controllerAnalise.enviar || this.controller.salvarConcluido || this.controller.envioConcluido || this.controller.salvarConcluido || this.controller.carregar);
    };

    recarregarLista = () => {
        (this.controller.envioConcluido || this.controller.salvarConcluido) && this.controllerAnalise.carregarAnalises();
    };

    chamaValidacao = () => {
        this.validacaoUn()
        this.validacaoEmail()
        this.validacaoCnpj()
        this.validacaoNcm()
    }

    handleEnviar = () => {
        this.chamaValidacao()
        this.controller.enviarParaAprovacao();
    }

    handleSalvar = () => {
        //validação de cada um dos campos obrigatórios aqui
        this.chamaValidacao()
        this.controller.modalConfig.onClickSalvar()
    }

    modal = () => {
        return <ModalForm salvando={ this.controller.salvando }
                          esconderSalvar={ this.esconderSalvar() }
                          className={`area-form-modal modal-analise ${this.controller.carregar || this.controllerAnalise.enviar || this.controller.envioConcluido || this.controller.salvarConcluido  ? 'carregar' : ''}`}
                          classContainer="modal-layer"
                          labelEnviar={ <span className="btn-enviar">{this.controller.modalConfig.labelEnviar}</span> }
                          labelConfirmar={ this.controller.modalConfig.labelConfirmar }
                          labelCancelar={ this.controller.modalConfig.labelCancelar }
                          onClickCancelar={ () => { this.controllerAnalise.fecharModal(); this.recarregarLista() }}
                          onClickSalvar={ this.handleSalvar }
                          onClickEnviar={ (!this.controller.envioConcluido || this.controller.carregar) && this.handleEnviar} >

            <h2>{this.controller.modalConfig.modalTitulo}</h2>
            <Form>
                { this.controller.carregar ? <IconeCarregar tamanho="2x" /> : this.form() }
            </Form>

            { ((!this.controllerAnalise.enviar) && !this.controller.envioConcluido) && this.mensagemSubmit() }
        </ModalForm>
    };

    render() {
        return (
            <React.Fragment>
                { this.modal() }
            </React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/analise/components/ModalAnaliseCriticaForm.js